let callback: (() => void) | null = null;

export const setActionButtonCallback = (fn: (() => void) | null) => {
    callback = fn;
};

export const getActionButtonCallback = () => callback;